module.exports = __webpack_public_path__ + "img/파나소닉고로.532ea281.png";